export {default as FavouriteOrderTag} from './favourite-order-tag.component'